import variables from 'common/config/variables';
import { getScalablePixel } from 'common/utils';
import GlobalStyle from 'common/utils/GlobalStyle';

GlobalStyle.inject`
.stripe-view-skeleton {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 100%;
  padding: ${getScalablePixel(32)}px ${variables.SAFE_AREA_VIEW_PADDING}px;
  overflow: visible !important;

  .title {
    width: ${getScalablePixel(240)}px;
    height: ${getScalablePixel(18)}px;
  }

  .list {
    display: flex;
    flex-direction: row;
    width: 100%;
    & > * {
      margin-right: ${getScalablePixel(8)}px;
    }
  }
}
`;
